export enum BasketActionType {
  Set = 'basket/SET_BASKET',
  SetLoading = 'basket/LOADING_BASKET',
}
